import { Injectable } from "@angular/core";
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from "@angular/common/http";
import { Observable, throwError, catchError } from "rxjs";
import { Router } from "@angular/router";
import { PasswordExpiryService } from "../service/password-expiry.service";

@Injectable()
export class PasswordExpiredInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private passwordExpiryService: PasswordExpiryService
  ) {}

  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      catchError((err: unknown) => {
        if (err instanceof HttpErrorResponse && err.status === 403) {
          const body = err.error;
          if (
            body &&
            typeof body === "object" &&
            (body as { error?: string }).error === "PASSWORD_EXPIRED"
          ) {
            this.passwordExpiryService.setExpired();
            this.router.navigate(["/auth/change-password"]);
          }
        }
        return throwError(() => err);
      })
    );
  }
}
